import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BaseService} from '../../../shared/services/base.service';
import {ApiResponse} from '../../../shared/model/api-response';
import {GameTable} from '../../../shared/model/game-table';
import {Game} from '../../../shared/model/game';
import {GameTableFilter} from '../../../shared/model/game-table-filter';

@Injectable({
  providedIn: 'root',
})
export class GameTablesService extends BaseService {

  private httpClient: HttpClient = inject(HttpClient);

  public getAllTables(includePast: boolean = false): Observable<ApiResponse<Array<GameTable>>> {
    const params = new HttpParams().set('includePast', includePast);
    return this.httpClient.get<ApiResponse<Array<GameTable>>>(`${this.baseUrl}/game-tables`, { params });
  }

  public getTableById(id: number): Observable<ApiResponse<GameTable>> {
    return this.httpClient.get<ApiResponse<GameTable>>(`${this.baseUrl}/game-tables/${id}`);
  }

  public getMineTables(): Observable<ApiResponse<Array<GameTable>>> {
    return this.httpClient.get<ApiResponse<Array<GameTable>>>(`${this.baseUrl}/game-tables/mine`);
  }

  public getTableBySearchParams(gameTableFilter: GameTableFilter | undefined, includePast: boolean = false): Observable<ApiResponse<Array<GameTable>>> {
    let params = new HttpParams().set('includePast', includePast);

    if (gameTableFilter) {
      if (gameTableFilter.tableName) {
        params = params.set('tableName', gameTableFilter.tableName);
      }
      if (gameTableFilter.gameName) {
        params = params.set('gameName', gameTableFilter.gameName);
      }
      if (gameTableFilter.location) {
        params = params.set('location', gameTableFilter.location);
      }
    }

    return this.httpClient.get<ApiResponse<Array<GameTable>>>(`${this.baseUrl}/game-tables/search`, { params });  }

  public createTable(gameTable: Partial<GameTable>): Observable<ApiResponse<GameTable>> {
    return this.httpClient.post<ApiResponse<GameTable>>(`${this.baseUrl}/game-tables`, gameTable);
  }

  public updateTable(gameTable: Partial<GameTable>): Observable<ApiResponse<GameTable>> {
    return this.httpClient.put<ApiResponse<GameTable>>(`${this.baseUrl}/game-tables/update`, gameTable);
  }

  public deleteTable(id: number): Observable<ApiResponse<string>> {
    return this.httpClient.delete<ApiResponse<string>>(`${this.baseUrl}/game-tables/${id}`);
  }

}









